module.exports = __webpack_public_path__ + "img/1527984094.b421f98c.jpg";